import { ADMIN_SCOPED_ROLES, getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

import { client } from '../client';
import { IOneReport } from './types/IOneReport';

interface IUpdateOneReportNote {
  note: string;
}

// Patient-visible "Case notes" — distinct from internal notes. The backend
// handler is dual-registered on `/notes` and `/internal_notes` for every
// role-scoped router (care_advisor, provider, collector, admin) and the
// unprefixed fallback. Admin/SuperAdmin/OrganizationAdmin use the dedicated
// `/admin/one_reports/...` sub-router (inline role + org gates). Other staff
// roles use their scoped prefix; Patient falls through to the unprefixed
// route.
export const addOneReportNote = async (
  one_report_id: string,
  payload: IUpdateOneReportNote,
  userRole?: string,
): Promise<IOneReport> => {
  const url =
    userRole && ADMIN_SCOPED_ROLES.has(userRole)
      ? `/admin/one_reports/${one_report_id}/notes`
      : `${getStaffScopedApiPrefix(userRole)}/one_reports/${one_report_id}/notes`;
  const { data } = await client.post<IOneReport>(url, payload);

  return data;
};
